import { DataService } from './../../../../../services/data.service';
import { BreadCrumb } from './../../../../../interfaces/main';
import { ReviewType } from './../../../../../interfaces/enums';
import { AuthService } from './../../../../../services/auth.service';
import { Student } from './../../../../../interfaces/user';
import { Lesson, Enrollment } from './../../../../../interfaces/course';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import * as _ from 'lodash';
import swal from 'sweetalert2';
import { BehaviorSubject, Observable } from 'rxjs';
import { State } from 'src/app/interfaces/enums';

enum Tabs{
  Descriptions = 1,
  Sessions = 2,
  Teachers = 3,
  Reviews = 4
}

@Component({
  templateUrl: './single.component.html',
  styleUrls: ['./single.component.scss']
})

export class SingleCourseComponent implements OnInit {
  isSchoolAdmin$: Observable<any>;
  isTeacher = false;

  Tabs = Tabs;
  ReviewType = ReviewType;

  canLeaveReviewSubject = new BehaviorSubject(false);

  lesson: Lesson;
  relatedLessons: Lesson[];

  attendees: any;

  enrollments: Enrollment[];
  myEnrollments: any[];

  currentTab = Tabs.Descriptions;

  user: Student;

  breadcrumbs: BreadCrumb[] = [{
    link: 'Home',
    url: ['/']
  },{
    link: 'Courses',
    url: ['/courses']
  }];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private auth: AuthService,
    private data: DataService
  ) { }

  ngOnInit() {

    this.isSchoolAdmin$ = this.auth.isSchoolAdmin();

    this.route.params.subscribe(async (p) => {
      if(p.courseid && p.lessonid){
        this.getData(p.courseid, p.lessonid);
        this.user = await this.auth.getUser() as Student;
      }else{
        this.router.navigate(['/courses']);
      }
    })
  }

  getData(courseid: string, lessonid: string){
    this.data.getLesson(courseid, lessonid).subscribe((res) => {
      if(res && res.data){
        this.lesson = res.data;

        this.breadcrumbs.length = 2;
        this.breadcrumbs.push({
          link: this.lesson.course.topic
        })

        this.lesson.sessions = _.filter(this.lesson.sessions, v => v.state === State.Active);

        this.isTeacher = this.user && this.lesson.teacher_id === this.user._id;

        this.getRelatedLessons();
        this.getEnrollments();
        this.canLeaveReview();
      }
    })
  }

  getEnrollments(){
    this.data.getEnrollments({
      course: this.lesson.course_id,
      lesson: this.lesson._id,
      teacher: this.lesson.teacher_id,
      state: State.Active
    }).subscribe((res) => {
      if(res && res.data){
        this.attendees = {};

        for(let i of _.map(this.lesson.sessions, v => v._id)){
          Object.defineProperty(this.attendees, i, {
            writable: true,
            enumerable: true,
            value: 0
          })
        }

        for(let i of res.data){
          this.attendees[i.session] += 1;
        }

        this.enrollments = res.data;
        this.myEnrollments = this.user ? _.map(_.filter(res.data, (i) => this.user && i.student_family === this.user._id), (v) => v.session) : [];
      }
    })
  }

  async getRelatedLessons(){
    this.data.getLessons('', {
      limit: 3
    }).subscribe((res) => {
      if(res && res.data){
        this.relatedLessons = res.data;
      }
    })
  }

  async enroll(session_id: string){
    try{
      if(!this.user){
        this.router.navigate(['/authentication/signin'], {
          queryParams: {
            redirect_url: this.route.snapshot.url.join('%2F')
          }
        });
        return;
      }

      if(!this.user.balance || this.user.balance < this.lesson.credits_per_session){
        swal.fire({
          type: 'info',
          title: 'Oops',
          text: 'You don\'t have enough credits. Do you want to buy more credits?',
          showCancelButton: true,
          confirmButtonText: 'Buy more'
        }).then(({value}) => {
          if(value){
            this.router.navigate(['/profile/balance']);
          }
        })
        return;
      }

      const inputOptions = {};

      for(let i of this.user.children){
        if(_.find(this.enrollments, {
          session: session_id,
          student: i._id
        })){
          continue;
        }

        Object.defineProperty(inputOptions, i._id, {
          value: `${i.name} - ${i.age}`,
          writable: true,
          enumerable: true
        })
      }

      if(!_.size(inputOptions)){
        swal.fire({
          type: 'info',
          title: 'Enrolling',
          text: 'All students are currently enrolled!'
        })
        return;
      }

      swal.fire({
        title: 'Enrolling',
        text: 'Please select children to enroll.',
        input: 'select',
        inputOptions: inputOptions,
        inputPlaceholder: 'Select children',
        showCancelButton: true,
        inputValidator: (value) => {
          return value ? '' : 'You need to select something.';
        }
      }).then(async (res) => {
        if(res.value){
          this.data.addEnrollments({
            student: res.value,
            student_family: this.user._id,
            course: this.lesson.course_id,
            lesson: this.lesson._id,
            session: session_id,
            teacher_name: this.lesson.teacher.name
          }).subscribe((res) => {
            if(res && res.data){
              this.getData(this.lesson.course_id, this.lesson._id);
            }
          })
        }
      })

    }catch(e){
      this.toastr.error(e.message);
    }
  }

  /**
   * Functions checks if user is allowed to leave a review
   */
  canLeaveReviewObservable = () => this.canLeaveReviewSubject.asObservable();
  async canLeaveReview(){
    if(!this.user){
      this.canLeaveReviewSubject.next(false);
      return;
    }

    this.data.getReviews({from: this.user._id, to: this.lesson._id}).subscribe((res) => {
      if(res && res.data){
        this.canLeaveReviewSubject.next(!res.data.length);
      }
    })
  }
}
